import { render, staticRenderFns } from "./PhotosGallery.vue?vue&type=template&id=8d456d2e&scoped=true&"
import script from "./PhotosGallery.vue?vue&type=script&lang=js&"
export * from "./PhotosGallery.vue?vue&type=script&lang=js&"
import style0 from "./PhotosGallery.vue?vue&type=style&index=0&id=8d456d2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d456d2e",
  null
  
)

export default component.exports